export default "__VITE_ASSET__BoFgoFa4__"